var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticStyle:{"position":"relative","height":"320px","width":"100%"}},[_c('canvas',{ref:"lienzo"})]),_c('p',{staticClass:"small text-muted mt-2 mb-0"},[_vm._v(" Curva de alerta CLAP/OPS (percentil 10) según posición, paridad y estado de las membranas. El eje horizontal son las horas desde que la dilatación alcanzó 4 cm. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }